import { render, staticRenderFns } from "./UnpublishedNewsList.vue?vue&type=template&id=3e52b45a&scoped=true&"
import script from "./UnpublishedNewsList.vue?vue&type=script&lang=js&"
export * from "./UnpublishedNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e52b45a",
  null
  
)

export default component.exports